import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

export default forwardRefWithTranslation('product-editor')(
    class Comment extends React.PureComponent {
        static propTypes = {
            comment: PropTypes.string.isRequired,
            onChange: PropTypes.func.isRequired,
            t: PropTypes.func.isRequired,
        };

        render = () => (
            <div
                className="m2g-product-editor-comment m2g-input-container m2g-form-element--full-width"
                data-icon-before
            >
                <input
                    className="m2g-product-editor-comment-input m2g-input m2g-input-container m2g-form-element--full-width"
                    data-comment
                    type="text"
                    placeholder={this.props.t('note')}
                    value={this.props.comment}
                    onChange={e => {
                        this.props.onChange(e.target.value);
                    }}
                />
                <span className="m2g-icon m2g-icon--comment" />
            </div>
        );
    }
);
